<section class="container ngx-toastr toast-info">
  <div class="title">{{ title }}</div>
  <div class="message">{{ message }}</div>
  <mat-progress-bar mode="determinate" color="accent" [value]="progress"></mat-progress-bar>
  @if (isCancelVisible) {
    <button [disabled]="!isCancelEnabled" mat-flat-button color="warn" (click)="onCancel()">{{ cancelText }}</button>
  }
</section>
